// atomic ui components
import { computed, inject } from 'vue';
import { VIRTUAL_ADVISOR_SKELETON_DATA_ATTRS } from '../../constants/SalesFloor';

export default function useVirtualAdvisor() {
  const virtualAdvisorWidgetName = inject('virtualAdvisorWidgetName');
  return {
    virtualAdvisorLoaderProps: computed(() => VIRTUAL_ADVISOR_SKELETON_DATA_ATTRS?.[virtualAdvisorWidgetName?.value] || {}),
    virtualAdvisorSkeletonClass: computed(() => `skeleton-loader--virtual-advisor--${virtualAdvisorWidgetName?.value}`),
  };
}
